angular.module('components.caArticleSelection', [])
    .component('caArticleSelection', {
        templateUrl: 'main/product/pricelisteditor/components/articleselection.component.tpl.html',
        controllerAs: 'vm',
        bindings: {
            onSearchContextChanged: '&'
        },
        controller: controller
    });

// @ngInject
function controller(loadSpinnerService, ToasterService, ProductsApiService, $translate) {
    var vm = this;
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;

    //Properties
    var defaultSalesChannel = { id: null, salesChannelDescription: $translate.instant('common.all') };
    vm.salesChannels = [defaultSalesChannel];
    var defaultArticleCollection = { id: null, collectionDescription: $translate.instant('common.all') };
    vm.articleCollections = [defaultArticleCollection];
    vm.searchTerm = '';
    vm.shouldGetOnlyNewArticles = false;
    vm.shouldGetOnlyCurrentArticles = false;
    vm.shouldGetOnlyArticlesWithSetPrices = false;
    vm.shouldGetOnlyArticlesWithVolumeDiscounts = false;
    vm.minPrice = 0;
    vm.maxPrice = 0;
    vm.usePriceRange = false;

    //Methods
    vm.selectedSalesChannel = defaultSalesChannel;
    vm.search = search;

    function onInit() {
        loadSpinnerService.start('mainSpinner');
        ProductsApiService.getSalesChannels().then(function(response) {
            vm.salesChannels = response;
            vm.salesChannels.unshift(defaultSalesChannel);
            vm.selectedSalesChannel = vm.salesChannels[0];
        }, function(error) {
            ToasterService.showError(error.message);
        });
        ProductsApiService.getArticleCollections().then(function(response) {
            vm.articleCollections = response;
            vm.articleCollections.unshift(defaultArticleCollection);
            vm.selectedArticleCollection = vm.articleCollections[0];
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function onChanges(changes) {
    }

    function onDestroy() {
    }

    function search() {
        loadSpinnerService.start('mainSpinner');

        var minPrice = 0;
        var maxPrice = 0;
        if (vm.usePriceRange) {
            minPrice = vm.minPrice;
            maxPrice = vm.maxPrice;
        }

        var salesChannelId = null;
        if (vm.selectedSalesChannel) { salesChannelId = vm.selectedSalesChannel.id; }

        var articleCollectionId = null;
        if (vm.selectedArticleCollection) { articleCollectionId = vm.selectedArticleCollection.id; }

        var request = {
            articleCollectionId: articleCollectionId,
            maxPrice: maxPrice,
            minPrice: minPrice,
            salesChannelId: salesChannelId,
            searchTerm: vm.searchTerm,
            shouldOnlyGetArticlesWithManualPrices: vm.shouldGetOnlyArticlesWithSetPrices,
            shouldOnlyGetArticlesWithVolumeDiscounts: vm.shouldGetOnlyArticlesWithVolumeDiscounts,
            shouldGetOnlyCurrentArticles: vm.shouldGetOnlyCurrentArticles,
            shouldGetOnlyNewArticles: vm.shouldGetOnlyNewArticles
        };

        ProductsApiService.getProductIds(request).then(function(response) {
            var searchContext = {
                articleCollectionId: articleCollectionId,
                articleIds: response.data,
                saleschannelId: salesChannelId
            };
            vm.onSearchContextChanged({ searchContext: searchContext });
        }, function(error) {
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

}
